const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Invitations} Invitations the resource defined to manage Invitations
 */
app.directive('addUserSingle', ['Application', 'Authorization', 'AccessHelper', 'Partners', 'Users', '$translate', function(Application, Authorization, AccessHelper, Partners, Users, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        manager: '@?',
        managerConfiguration: '=?',
        onAdd: '&?'
      },
      template: require('../../templates/directives/add-user-single.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.flags = Application.features.flags();
          self.creator = Application.access.user;
          self.datepickerFormat = Application.dateFormatting.getAngularJSDateFormat();
          self.momentFormat = Application.dateFormatting.getMomentFormat();
          self.dateFromString = function(string) {
            return moment(string, self.momentFormat).toDate();
          };

          var arraySegmentationTypes = {
            linked_departments: true,
            linked_locations: true,
            linked_teams: true,
            groups: true
          };

          var userToLabel = {
            linked_departments: 'Department',
            linked_locations: 'Location',
            linked_teams: 'Teams',
            linked_org_level: 'Level',
            linked_grade: 'Grade',
            groups: 'Groups'
          };

          self.allowance = {
            add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin', 'manager']),
            edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
            view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
            view_restricted: AccessHelper.isAllowed(['admin', 'users', 'restricted_access'], null, ['admin', 'creator', 'manager']),
            suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
            password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin']),
            admin_set: AccessHelper.isAllowed(['admin', 'users', 'admin_set'], null, ['admin']),
            creator_set: AccessHelper.isAllowed(['admin', 'users', 'creator_set'], null, ['admin', 'creator', 'manager']),
            profile_set: AccessHelper.isAllowed(['admin', 'users', 'profile_set'], null, ['admin', 'creator', 'manager']),
            manager_set: AccessHelper.isAllowed(['admin', 'users', 'manager_set'], null, ['admin', 'creator', 'manager']),
            buddy_set: AccessHelper.isAllowed(['admin', 'users', 'buddy_set'], null, ['admin', 'creator', 'manager']),
            external_users: AccessHelper.isAllowed(['admin', 'users', 'external_users'], null, ['admin', 'creator', 'manager']),
          };

          if (!self.allowance.add) {
            Application.navigation.goTo('/explore');
            return;
          }

          self.required = ['first_name', 'last_name', 'role', 'language'];
          self.signin_userid = Application.features.flags().signin_userid;
          self.signin_userid_copy = {field_name: 'User-ID'};
          if (self.signin_userid && Authorization.getAuthToken().company.signin_userid_copy) {
            self.signin_userid_copy = Authorization.getAuthToken().company.signin_userid_copy;
          }
          self.partners = [];
          var requireMessages = {
            first_name: 'first name',
            last_name: 'last name',
            email: 'email',
            userid: 'userid',
            role: 'user type',
            language: 'language'
          };
          self.segmentationAdd = function() {
            if ($scope.onAdd) {
              $scope.onAdd();
            }
          };
          self.segmentationCancel = function() {
            self.showManagerEdit = false;
          };
          // ---- Role related
          self.chooseRole = function(index) {
            self.user.role = self.roles[index].value;
          };
          self.inputClick = function(index) {
            var input = document.getElementById('role-' + index);
            setTimeout(function() {
              input.click();
            }, 1);
          };
          self.stopProp = function(evt) {
            evt.stopPropagation();
          };
          // ---- End Role related

          self.submitUser = function(invalidEmail) {
            var missing = '';
            if (invalidEmail) {
              Application.messaging.addMessage({type: 'error', text: 'Error. Please provide a valid email.', duration: 5});
              return;
            }
            for (var i = 0; i < self.required.length; i++) {
              if (!self.user[self.required[i]]) {
                missing += requireMessages[self.required[i]] + ', ';
              }
              if (Application.features.flags().signin_userid) {
                if (!self.user.userid && !self.user.email) {
                  missing += (self.signin_userid_copy.field_name) + ', ';
                }
              } else {
                if (!self.user.email) {
                  missing += 'email' + ', ';
                }
              }
            }
            if (missing) {
              Application.messaging.addMessage({type: 'error', text: 'Error. Please complete the following field(s): ' + missing.slice(0, -2), duration: 5});
              return;
            }

            if (self.hired) {
              self.user.hired = self.dateFromString(self.hired);
            }

            self.loading = true;
            var filter;
            if (!Application.features.flags().signin_userid) {
              filter = {email: self.user.email.toLowerCase()};
            } else {
              if (self.user.userid && !self.user.email) {
                filter = {userid: self.user.userid.trim()};
              } else {
                filter = {email: self.user.email.toLowerCase()};
              }
            }
            Users.find(filter).$promise.then(function(matches) {
              if (matches.length) {
                self.loading = false;
                self.existingUser = matches[0];
                if ($scope.manager) {
                  self.showManagerEdit = true;
                  return;
                }
                if (!Application.features.flags().signin_userid) {
                  Application.messaging.addMessage({type: 'error', text: 'Error. A user with this email address already exists.', duration: 5});
                } else {
                  if (self.user.userid && !self.user.email) {
                    Application.messaging.addMessage({type: 'error', text: 'Error. A user with this ' + (self.signin_userid_copy.field_name) + ' already exists.', duration: 5});
                  } else {
                    Application.messaging.addMessage({type: 'error', text: 'Error. A user with this email address already exists.', duration: 5});
                  }
                }
                return;
              }

              if ($scope.manager && $scope.managerConfiguration && $scope.managerConfiguration.segmentation_required && $scope.managerConfiguration.segmentation_required.length) {
                var missingRequirement = '';

                $scope.managerConfiguration.segmentation_required.forEach(function(item) {
                  var arrayType = arraySegmentationTypes[item];
                  var label = userToLabel[item] || item;
                  if (missingRequirement) {
                    label = ', ' + label;
                  }
                  
                  if (!self.user[item]) {
                    missingRequirement += label;
                    return;
                  }
                  if (arrayType && !self.user[item].length) {
                    missingRequirement += label;
                  }
                });
                
                if (missingRequirement) {
                  Application.messaging.addMessage({type: 'error', text: 'Please fill out all required fields, including: ' + missingRequirement + '.', duration: 7});
                  self.loading = false;
                  return;
                }
              }

              Users.create({}, self.user).$promise.then(function(invitation) {

                if (!Application.features.flags().signin_userid) {
                  Application.messaging.addMessage({type: 'success', text: 'Success! An invitation has been sent to ' + self.user.first_name + ' ' + self.user.last_name + ' at ' + self.user.email + '.', duration: 5});
                } else {
                  if (self.user.userid && !self.user.email) {
                    Application.messaging.addMessage({type: 'success', text: 'Success! User ' + self.user.first_name + ' ' + self.user.last_name + ' can begin using Continu now.', duration: 5});
                  } else {
                    Application.messaging.addMessage({type: 'success', text: 'Success! An invitation has been sent to ' + self.user.first_name + ' ' + self.user.last_name + ' at ' + self.user.email + '.', duration: 5});
                  }
                }
                for (var key in self.user) {
                  if (typeof self.user[key] === 'string') {
                    if (key !== 'job_type' && key !== 'language') {
                      self.user[key] = '';
                    }
                  }
                }
                self.loading = false;
                self.initialize();
                $scope.addUserForm.email.$setPristine();
                if ($scope.onAdd) {
                  $scope.onAdd();
                }
              }).catch(function(error) {
                var message = error.status && error.status === 409 && error.data && error.data.message ? error.data.message : 'Error. An error occurred inviting this user.';
                Application.messaging.addMessage({type: 'error', text: message, duration: 5});
                self.loading = false;
                $scope.addUserForm.email.$setPristine();
              });
            }).catch(function(error) {
              Application.messaging.addMessage({
                type: 'error',
                text: self.translations['manage.users.inviteError'],
                duration: 5});
              self.loading = false;
              $scope.addUserForm.email.$setPristine();
            });
          };
         
          $scope.$watch('userAdd.user.partner', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
                return;
              }
            if (newVal.length && self.user.role !== 'user') {
              self.user.partner = oldVal;
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['partners.userRole.message']});
            }
          });
        
          $scope.$watch('userAdd.user.role', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }
            if (newVal !== 'user' && self.user.partner?.length) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['partners.userRole.message']});
              self.user.role = 'user';
              self.chosenRole = 'user';
            }
          });

          self.initialize = function() {
            self.loading = false;

            self.languages = [];
            var languages = Application.languages.getAvailable();
            $translate(languages.map(function(item) {
              return item.name;
            })).then(function(data) {
              self.languages = languages.map(function(item) {
                if (data[item.name]) {
                  item.name = data[item.name];
                }
                return item;
              });
            });

            self.chosenRole = null;
            self.user = {
              job_type: 'SV',
              language: languages[0].value,
              linked_teams: [],
              linked_locations: [],
              linked_departments: [],
              groups: [],
              is_manager: false,
              managing_groups: [],
              manager_configuration: {
                disable_assignments: false,
                allow_user_creation: false,
                segmentation_required: [],
                segmentation_subset: [],
                hide_options: [],
                allow_user_edit: false,
                restricted_user_edit: false,
                restricted_editable_fields: [],
                allow_adding_group_manager: false,
                disable_assignment_edit: false,
                disable_assignment_completion: false,
                disable_assignment_removal: false
              }
            };

            if ($scope.manager) {
              self.user.role = 'user';
            }
            self.initComplete = true;      
          };

          Partners.find({perPage: 9999999}).$promise.then(function(partners) {
            self.partners = partners;
            const partnersDropdown = partners.map(part => {
              return {
                value: part._id,
                name: part.name.toString().trim(),
              }
            });
            partnersDropdown.sort((a, b) => { return a.name < b.name; });
            self.partners = [{name: "Select Extend Account", value: ""}, ...partnersDropdown];
            self.user.partner = self.user.partner || "";
            self.user.partner_role = self.user.partner_role || 'user';
          });

          $translate([
            'manage.users.creator',
            'manage.users.external',
            'manage.users.administrator',
            'manage.users.user',
            'manage.partner.principal',
            'manage.users.inviteError',
            'partners.userRole.message'
          ]).then(function(data) {
            self.translations = data;
            self.roles = [
              {name: self.translations['manage.users.user'], value: 'user'},
            ];
            if (self.allowance.creator_set) {
              self.roles.push({name: self.translations['manage.users.creator'], value: 'creator'});
            }
            if (self.allowance.admin_set) {
              self.roles.push({name: self.translations['manage.users.administrator'], value: 'admin'});
            }
            if (Authorization.getAuthToken().company.external_users && self.allowance.external_users) {
              self.roles.push({name: self.translations['manage.users.external'], value: 'external'});
            }
            self.partnerRoles = [
              {name: self.translations['manage.users.user'], value: 'user'},
              {name: self.translations['manage.partner.principal'], value: 'principal'}
            ]
  
            self.initialize();
          });

        }],
      controllerAs: 'userAdd'
    };
  }]);

